module.exports = __webpack_public_path__ + "static/img/preview-7.e8b6149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/preview-7.png
// module id = 7fYO
// module chunks = 35